import React from 'react';

// §7 其他 — 纽扣 button group + 金属纽扣 (bridge/muzzle-button=metal) + 加耳朵孔/加眼镜孔 (ear-hole/glass-hole)
// HOOD mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function OtherSection({ config, parts, ellipses }) {
  return (
    <>
<g id="button">
 <ellipse className={"hood-" + config['bridge-button'] + " str-button"} transform={(ellipses['bridge-button_c'] || {}).transform} rx={(ellipses['bridge-button_c'] || {}).rx} ry={(ellipses['bridge-button_c'] || {}).ry}/>
 <path className="fil-button-light" d={parts['button-light-path-212'] || ''}/>
 <path className="fil-button-light" d={parts['button-light-path-213'] || ''}/>
 <ellipse className={"hood-" + config['muzzle-button'] + " str-button"} transform={(ellipses['muzzle-button_c'] || {}).transform} rx={(ellipses['muzzle-button_c'] || {}).rx} ry={(ellipses['muzzle-button_c'] || {}).ry}/>
 <path className="fil-button-light" d={parts['button-light-path-214'] || ''}/>
 <path className="fil-button-light" d={parts['button-light-path-215'] || ''}/>
 <ellipse className={"hood-" + config['muzzle-button-b'] + " str-button"} transform={(ellipses['muzzle-button_c_2'] || {}).transform} rx={(ellipses['muzzle-button_c_2'] || {}).rx} ry={(ellipses['muzzle-button_c_2'] || {}).ry}/>
 <path className="fil-button-light" d={parts['button-light-path-216'] || ''}/>
 <path className="fil-button-light" d={parts['button-light-path-217'] || ''}/>
</g>
{config['bridge-button'] === 'metal' ? <g id="bridge-button-silver">
 <path fill="#E62629" d={parts['clear-path-219'] || ''}/>
 <g style={{clipPath:"url(#id0)"}}>
  <g>
   <rect fill="url(#id3)" x="12377" y="9273" width="686" height="747"/>
  </g>
 </g>
 <path className="clear str_222222_8" d={parts['clear-path-219'] || ''}/>
 <path fill="#FEFEFE" d={parts['fill-FEFEFE-path-220'] || ''}/>
 <path fill="#FEFEFE" d={parts['fill-FEFEFE-path-221'] || ''}/>
 </g> : <g/>}
{config['muzzle-button'] === 'metal' ? <g id="muzzle-button-silver">
 <path fill="#E62629" d={parts['clear-path-223'] || ''}/>
 <g style={{clipPath:"url(#id1)"}}>
  <g>
   <rect fill="url(#id4)" x="7413" y="12748" width="686" height="747"/>
  </g>
 </g>
 <path className="clear str_222222_8" d={parts['clear-path-223'] || ''}/>
 <path fill="#FEFEFE" d={parts['fill-FEFEFE-path-224'] || ''}/>
 <path fill="#FEFEFE" d={parts['fill-FEFEFE-path-225'] || ''}/>
</g> : <g/>}
{config['muzzle-button-b'] === 'metal' ? <g id="muzzle-button-b-silver">
 <path fill="#E62629" d={parts['clear-path-227'] || ''}/>
 <g style={{clipPath:"url(#id2)"}}>
  <g>
   <rect fill="url(#id5)" x="7630" y="14610" width="686" height="747"/>
  </g>
 </g>
 <path className="clear str_222222_8" d={parts['clear-path-227'] || ''}/>
 <path fill="#FEFEFE" d={parts['fill-FEFEFE-path-228'] || ''}/>
 <path fill="#FEFEFE" d={parts['fill-FEFEFE-path-229'] || ''}/>
</g> : <g/>}
{config['glass-hole'] ? <g id="glass-hole">
 <path className="fil-eye" d={parts['eye-path-230'] || ''}/>
 <path className="clear str_332C2B_20" d={parts['clear-path-231'] || ''}/>
 <path className="fil-eye str_332C2B_20" d={parts['eye-path-232'] || ''}/>
 <path className="fil-eye str_332C2B_20" d={parts['eye-path-233'] || ''}/>
</g> : <g/>}
{config['ear-hole'] ? <g id="ear-hole">
 <g>
  <path className="fil-eye-border" d={parts['eye-border-path-234'] || ''}/>
  <path className="fil-eye" d={parts['eye-path-235'] || ''}/>
  <path className="clear str_332C2B_20" d={parts['clear-path-236'] || ''}/>
  <circle className="clear str_332C2B_20" transform={(ellipses['circle-1'] || {}).transform} r={(ellipses['circle-1'] || {}).r}/>
 </g>
 <g>
  <path className="fil-eye-border" d={parts['eye-border-path-237'] || ''}/>
  <path className="fil-eye" d={parts['eye-path-238'] || ''}/>
  <path className="clear str_332C2B_20" d={parts['clear-path-239'] || ''}/>
  <circle className="clear str_332C2B_20" transform={(ellipses['circle-2'] || {}).transform} r={(ellipses['circle-2'] || {}).r}/>
 </g>
 <g>
  <path className="fil-eye-border" d={parts['eye-border-path-240'] || ''}/>
  <path className="fil-eye" d={parts['eye-path-241'] || ''}/>
  <path className="clear str_332C2B_20" d={parts['clear-path-242'] || ''}/>
  <circle className="clear str_332C2B_20" transform={(ellipses['circle-3'] || {}).transform} r={(ellipses['circle-3'] || {}).r}/>
 </g>
 <g>
  <path className="fil-eye-border" d={parts['eye-border-path-243'] || ''}/>
  <path className="fil-eye" d={parts['eye-path-244'] || ''}/>
  <path className="clear str_332C2B_20" d={parts['clear-path-245'] || ''}/>
  <circle className="clear str_332C2B_20" transform={(ellipses['circle-4'] || {}).transform} r={(ellipses['circle-4'] || {}).r}/>
 </g>
</g> : <g/>}
    </>
  );
}
